import {
  Component,
  OnInit,
  ViewChild,
  EventEmitter,
  Output,
} from "@angular/core";
import { OffboardingEmployeeListComponent } from "../offboarding-employee-list/offboarding-employee-list.component";
import { Router, ActivatedRoute } from "@angular/router";
import {
  DateAdapter,
  MatDialog,
  MatTableDataSource,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material";
import { Toast, ToastrService } from "ngx-toastr";
import { UserService } from "../../shared/service/user.service";
import { EmployeeService } from "../../shared/service/employee.service";
import { OffboardingCheckListResultClass } from "../../shared/models/OffboardingCheckListResultClass";
import { debug, isNullOrUndefined } from "util";
import { Offboarding } from "../../shared/models/Offboarding";
import { OffbaordingFeedbackTypeClass } from "../../shared/models/OffbaordingFeedbackTypeClass";
import {
  FormControl,
  FormGroup,
  Validators,
  FormBuilder,
} from "@angular/forms";
import {
  ConfirmDialogModel,
  ConfirmDialogComponent,
} from "../../shared/components/confirm-dialog/confirm-dialog.component";
import { EmpFBAnswers } from "../../shared/models/EmpFBAnswers";
import { EmpFbQuestions } from "../../shared/models/EmpFbQuestions";
import { MatRadioModule } from "@angular/material";
import { MatRadioChange } from "@angular/material";
import { DepartmentsService } from "../../departments.service";
import * as _moment from "moment";
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from "@angular/material-moment-adapter";
import { Employee } from "../../../Models/Employee";
import { MapOperator } from "rxjs/internal/operators/map";
import { Moment } from "moment";
import { DatePipe } from "@angular/common";
import { AppConfig } from "../../app.config";
import { HREmployeeDetails } from "../../shared/models/hremployeecommunicationdetails.model";
import { BasicEmployeeDetails } from "../../shared/models/basicemployeedetails.model";

const moment = _moment;
export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MMM-YYYY",
  },
  display: {
    dateInput: "DD-MMM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: "app-offboarding-feedback",
  templateUrl: "./offboarding-feedback.component.html",

  styleUrls: ["./offboarding-feedback.component.css"],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class OffboardingFeedbackComponent implements OnInit {
  dataSourceFTE: any;
  dataSourceIT: any;
  dataSourceAdmin: any;
  dataSourceManager: any;
  dataSourceHR: any;
  error: any;
  offboardingresult: any[] = [];
  offboardingresultRadio: any[] = [];
  checklistForm: FormGroup;
  onlyCode: any;
  checklist: OffbaordingFeedbackTypeClass[] = [];
  resultArray: OffboardingCheckListResultClass[] = [];
  empCode: any;
  email: any;
  test: any;
  code: any;
  feedbacktype: any;
  feedbacktypeAccordions: any;
  employeeCode: any;
  employeeId: FormControl;
  Comments: any;
  HRExitInterviewNotes: any;
  ResignationComments: any;
  offboardingform: Offboarding;
  radiobutton: number;
  commentForm: FormGroup;
  commentschecklist: OffboardingCheckListResultClass;
  uncheck: OffboardingCheckListResultClass;
  answerarray: EmpFBAnswers[] = [];
  tempArray: EmpFBAnswers[] = [];
  questionsArray: EmpFbQuestions[] = [];
  finalfeedbackchecklist: any[] = [];
  finalfeedbackresult: any[] = [];
  managercount: number;
  admincount: number;
  itcount: number;
  result: any;
  ManagerFB: string;
  ITFB: string;
  AdminFB: string;
  tooltipdata: any;
  onlyifexits: boolean;
  employeefbquestions: any[] = [];
  dataSource: any;
  answers: EmpFBAnswers;
  arrayAns: any[] = [];
  question: any[] = [];
  offboardingemployeelistcomp: OffboardingEmployeeListComponent;
  accordionManager: OffboardingCheckListResultClass[] = [];
  accordionIT: any[] = [];
  accordionAdmin: any[] = [];
  accordionHR: any[] = [];
  commentBooleanHR: boolean = false;
  formName: string;
  empDetails: BasicEmployeeDetails;
  readOnlyChecklist: boolean;
  disableSubmit: boolean = true;
  checkAlltrue: any[] = [];
  disableManagerForm: boolean = false;
  disableITForm: boolean = false;
  disableAdminForm: boolean = false;
  disableHRForm: boolean = false;
  radioNameYes: any;
  radioNameNo: any;
  radioNameNA: any;
  dropdownboolean: boolean;
  dropdownEmail: any;
  empName: any;
  todayDate: Date;
  empFFS: Date;
  employeeList: any[] = [];
  filteredList: any[] = [];
  EmployeeCode: any;
  tempdropdownList: dropObj[] = [];
  feedbackFinanceboolean: boolean = false;
  financeresultArray: OffboardingCheckListResultClass[] = [];
  recallOffboarding: Offboarding;
  finalbuttons: boolean = false;
  managerButtons: boolean;
  itButtons: boolean;
  adminButtons: boolean;
  hrButtons: boolean;
  disableHRformonFinSubmit: boolean;
  financeButtons: boolean;
  department: any;
  managerVerifiedList: any[] = [];
  datePipe: DatePipe;
  permission: any;
  joiningBonus: any;
  editEnable: boolean = false;
  loader: boolean;
  pmCodeClearanceList: Offboarding[] = [];
  isshowHide: boolean = true;
  offboardingresult_old: any[] = [];
  hrOffboardingID: any;

  constructor(
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private config: AppConfig,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private _userService: UserService,
    private empsvc: EmployeeService,
    private deptSvc: DepartmentsService,
    public router: Router
  ) {
    this.dataSourceFTE = new MatTableDataSource();
    this.dataSource = new MatTableDataSource();
    this.dataSourceIT = new MatTableDataSource();
    this.dataSourceManager = new MatTableDataSource();
    this.dataSourceHR = new MatTableDataSource();
    this.todayDate = new Date();
    this.empFFS = new Date();
    this.datePipe = new DatePipe("en-US");
    this.offboardingform = new Offboarding();
    this.empDetails = new BasicEmployeeDetails();
    this.recallOffboarding = new Offboarding();
  }
  displayedColumns: string[] = ["Description", "Yes"];
  displayedColumnsOne: string[] = ["Questions"];

  ngOnChanges() {}

  ngOnInit() {
    this.employeeCode = this._userService.getEmpCode();
    this.department = this._userService.getDepartment();
    this.getOffboardingdetailsbyCode();
    this.route.params.subscribe((params) => {
      this.feedbacktype = params["feedbacktype"];
      this.code = params["empCode"];
    });
    const currentMonth = this.todayDate.getMonth();
    const currentDay = this.todayDate.getDay();
    const currentYear = this.todayDate.getFullYear();
    this.empFFS = new Date(currentYear, currentMonth - 1, 1);
    const hrOffboardingIDTemp = localStorage.getItem("hrOffboardingID");
    this.hrOffboardingID = hrOffboardingIDTemp;
    if (!isNullOrUndefined(this.code)) {
      this.checklistForm = this.formBuilder.group({
        Yes: ["", [Validators.required]],
        No: ["", [Validators.required]],
        NA: ["", [Validators.required]],
      });
      (this.employeeId = new FormControl()), this.getEmployeeList();

      this.getEmpFBQuestions();
      this.getfbQuestionsandAnswers();
      this.getITAccordions();
      this.getAdminAccordions();
      this.getHRAccordions();
      this.geFinanceAccordions();
      this.GetFeedbackAnswersByCode();
      this.GetOffboardingChecklistResult();
      this.getOffboardingdetailsbyCode();
      this.getFormName();
      this.getEmpDetails();
    } else {
      this.checklistForm = this.formBuilder.group({
        Yes: ["", [Validators.required]],
        No: ["", [Validators.required]],
        NA: ["", [Validators.required]],
      });
      (this.employeeId = new FormControl()), this.getEmpFBQuestions();
      this.getchecklist();

      this.getFormName();
    }
    this.permission = this._userService.userInfo.permissions.find(
      (i) => i.Name === "Offboarding-list"
    );
    if (this.permission.HasFullAccess || this.permission.EditingPermission)
      this.editEnable = true;
    this.dataSourceFTE = new MatTableDataSource();
    this.dataSource = new MatTableDataSource();
    this.dataSourceIT = new MatTableDataSource();
    this.dataSourceAdmin = new MatTableDataSource();
    this.dataSourceManager = new MatTableDataSource();
    this.dataSourceHR = new MatTableDataSource();
  }
  getFormName() {
    if (this.feedbacktype == "Manager") {
      this.formName = "Offboarding Clearance Form - Reporting Manager";
    } else if (this.feedbacktype == "Admin") {
      this.formName = "Offboarding Clearance Form - Admin";
    } else if (this.feedbacktype == "HR") {
      this.formName = "Offboarding Clearance Form - HR";
    } else if (this.feedbacktype == "IT") {
      this.formName = "Offboarding Clearance Form - IT";
    } else if (this.feedbacktype == "Finance") {
      this.formName = "Offboarding Clearance Form - Finance";
    }
  }
  recallManager() {
    this.recallOffboarding.FeedbackType = "Manager";
    this.recallOffboarding.EmpCode = this.code;
    this.recallOffboarding.ManagerSubmittedBy =
      this.offboardingform.ManagerSubmittedBy;
    this.recallOffboarding.Name = this.offboardingform.Name;
    this.recallOffboarding.ID = this.hrOffboardingID;
    this.recallOffboarding.recallAdmin = this.offboardingform.SubmittedAdmin
      ? true
      : false;

    var msg = `Are you sure to recall Manager?`;
    var deleteType = "Submit";
    const dialogData = new ConfirmDialogModel(" ", msg, deleteType);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          window.scrollTo(0, 0);
          this.loader = true;
          this.empsvc.SaveRecallStatus(this.recallOffboarding).subscribe(
            (data: any) => {
              if (data.ErrorType == "Exception") {
                this.loader = false;
                this.toastr.warning(data.ErrorMsg);
              } else {
                this.toastr.success("Manager clearance recalled successfully.");
                this.loader = false;
                this.router.navigateByUrl(
                  `/Offboardinglist/tabIndex/${
                    Number(sessionStorage.getItem("tabIndex")) || 0
                  }`
                );
              }
            },
            (error) => this.toastr.warning(error)
          );
        }
      },
      (error) => {
        this.loader = false;
        this.result = error;
      }
    );
  }
  recallIT() {
    this.recallOffboarding.FeedbackType = "IT";
    this.recallOffboarding.EmpCode = this.code;
    this.recallOffboarding.ITSubmittedBy = this.offboardingform.ITSubmittedBy;
    this.recallOffboarding.Name = this.offboardingform.Name;
    this.recallOffboarding.ID = this.hrOffboardingID;
    this.recallOffboarding.recallAdmin = this.offboardingform.SubmittedAdmin
      ? true
      : false;
    this.recallOffboarding.recallManager = this.offboardingform.SubmittedManager
      ? true
      : false;

    var msg = `Are you sure to recall IT?`;
    var deleteType = "Submit";
    const dialogData = new ConfirmDialogModel(" ", msg, deleteType);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          window.scrollTo(0, 0);
          this.loader = true;

          this.empsvc.SaveRecallStatus(this.recallOffboarding).subscribe(
            (data: any) => {
              if (data.ErrorType == "Exception") {
                this.loader = false;
                this.toastr.warning(data.ErrorMsg);
              } else {
                this.toastr.success("IT clearance recalled successfully.");
                this.loader = false;

                this.router.navigateByUrl(
                  `/Offboardinglist/tabIndex/${
                    Number(sessionStorage.getItem("tabIndex")) || 0
                  }`
                );
              }
            },
            (error) => this.toastr.warning(error)
          );
        }
      },
      (error) => {
        this.loader = false;
        this.result = error;
      }
    );
  }
  recallAdmin() {
    this.recallOffboarding.FeedbackType = "Admin";
    this.recallOffboarding.EmpCode = this.code;
    this.recallOffboarding.AdminSubmittedBy =
      this.offboardingform.AdminSubmittedBy;
    this.recallOffboarding.ID = this.hrOffboardingID;
    this.recallOffboarding.Name = this.offboardingform.Name;

    this.recallOffboarding.recallManager = this.offboardingform.SubmittedManager
      ? true
      : false;
    this.recallOffboarding.recallIT = this.offboardingform.SubmittedIT
      ? true
      : false;

    var msg = `Are you sure to recall Admin?`;
    var deleteType = "Submit";
    const dialogData = new ConfirmDialogModel(" ", msg, deleteType);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          window.scrollTo(0, 0);
          this.loader = true;

          this.empsvc.SaveRecallStatus(this.recallOffboarding).subscribe(
            (data: any) => {
              if (data.ErrorType == "Exception") {
                this.loader = false;
                this.toastr.warning(data.ErrorMsg);
              } else {
                this.toastr.success("Admin clearance recalled successfully.");
                this.loader = false;
                this.router.navigateByUrl(
                  `/Offboardinglist/tabIndex/${
                    Number(sessionStorage.getItem("tabIndex")) || 0
                  }`
                );
              }
            },
            (error) => this.toastr.warning(error)
          );
        }
      },
      (error) => {
        this.loader = false;
        this.result = error;
      }
    );
  }
  autoGrowTextZone(e) {
    e.target.style.height = "0px";
    e.target.style.height = e.target.scrollHeight + 10 + "px";
  }
  checkFinalFeedbacks() {
    this.empsvc
      .getOffboardingFeedbackTypeDescription(this.feedbacktype, this.code)
      .subscribe(
        (data: any[]) => {
          this.finalfeedbackchecklist = data;
        },
        (error) => this.toastr.warning(error)
      );
    this.empsvc.GetOffboardingChecklistResult(this.code).subscribe(
      (data: any[]) => {
        this.finalfeedbackresult = data;
      },
      (error) => this.toastr.warning(error)
    );
  }
  SaveEmpFbAnswers() {
    if (this.answerarray.length == 0) {
      this.arrayAns = this.questionsArray;
      for (var i = 0; i < this.arrayAns.length; i++) {
        this.arrayAns[i].EmployeeCode = this.code;
        this.arrayAns[i].QuestionID = this.arrayAns[i].FeedbackQuestionID;
      }
    } else {
      this.arrayAns = this.answerarray;
    }

    this.empsvc.SaveEmpFbAnswers(this.arrayAns).subscribe(
      (data: EmpFBAnswers) => {
        // this.employeeCode = this._userService.getEmpCode();
      },
      (error) => (this.error = error)
    );
  }
  getEmpFbAnswers() {
    this.empsvc.getEmpFbAnswers().subscribe((data: EmpFBAnswers[]) => {});
  }
  getEmpFBQuestions() {
    this.empsvc.getEmpFbQuestions().subscribe((data: EmpFbQuestions[]) => {
      this.questionsArray = data;
    });
  }
  getfbQuestionsandAnswers() {
    this.empsvc.GetEmployeeQnAFeedbackAccordion(this.code).subscribe(
      (data: any[]) => {
        this.answerarray = data;
        if (this.answerarray.length == 0) {
          this.dataSource.data = this.questionsArray;
        } else {
          for (var i = 0; i < this.answerarray.length; i++) {
            if (this.answerarray[i].QuestionID == 1) {
              this.tempArray.push(this.answerarray[i]);
            }
          }
          for (var i = 0; i < this.answerarray.length; i++) {
            if (this.answerarray[i].QuestionID == 2) {
              this.tempArray.push(this.answerarray[i]);
            }
          }
          for (var i = 0; i < this.answerarray.length; i++) {
            if (this.answerarray[i].QuestionID == 3) {
              this.tempArray.push(this.answerarray[i]);
            }
          }
          this.dataSource.data = this.tempArray;
        }
      },
      (error) => (this.error = error)
    );
  }

  diffDays(d1, d2) {
    var ndays;
    var tv1 = d1.valueOf(); // msec since 1970
    var tv2 = d2.valueOf();

    ndays = (tv2 - tv1) / 1000 / 86400;
    ndays = Math.round(ndays - 0.5);
    return ndays;
  }

  getEmpListForLastTab() {
    this.empsvc.getEmpListByPMCodeAfterHR(this.employeeCode).subscribe(
      (data: Offboarding[]) => {
        this.pmCodeClearanceList = data;
        var financeList =
          this.pmCodeClearanceList &&
          this.pmCodeClearanceList.filter((x) => x.Status == "Completed");
        if (this.department != "Finance") {
          if (
            this.pmCodeClearanceList &&
            this.pmCodeClearanceList.length != 0
          ) {
            for (var i = 0; i < this.pmCodeClearanceList.length; i++) {
              if (this.pmCodeClearanceList[i].EmpCode == this.code) {
                this.offboardingform.enableEmpFeedback = true;
              }
            }
          }
        } else {
          if (financeList.length != 0) {
            for (var i = 0; i < financeList.length; i++) {
              if (financeList[i].EmpCode == this.code) {
                this.offboardingform.enableEmpFeedback = true;
              }
            }
          }
        }
      },
      (error) => (this.error = error)
    );
  }

  getOffboardingdetailsbyCode() {
    this.empsvc.getOffboardingDetails(this.code).subscribe((data: any) => {
      this.offboardingform = data;
      if (this.offboardingform.SubmittedHR == true) {
        this.disableHRformonFinSubmit = true;
      }
      if (this.offboardingform.SubmittedHR == true && this.editEnable == true) {
        if (
          this.offboardingform.SubmittedFinance == false ||
          this.offboardingform.SubmittedFinance == null
        ) {
          this.disableHRformonFinSubmit = false;
        } else {
          this.disableHRformonFinSubmit = true;
        }
      }
      if (this.offboardingform.Status == "Completed") {
        this.finalbuttons = true;
      } else {
        this.finalbuttons = false;
      }
      if (this.offboardingform.ManagerFeedBack == true) {
        this.managerButtons = true;
      } else {
        this.managerButtons = false;
      }

      if (this.offboardingform.ITSupportFeedback == true) {
        this.itButtons = true;
      } else {
        this.itButtons = false;
      }
      if (this.offboardingform.AdminFeedBack == true) {
        this.adminButtons = true;
      } else {
        this.adminButtons = false;
      }
      if (this.offboardingform.HRFinalFeedback == true) {
        this.hrButtons = true;
      } else {
        this.hrButtons = false;
      }
      if (this.offboardingform.FinanceFeedback == true) {
        this.financeButtons = true;
      } else {
        this.financeButtons = false;
      }
    });
  }

  getchecklist() {
    // this.resultArray = [];
    if (this.feedbacktype == "Finance") {
      this.feedbacktype = "HR";
      this.feedbackFinanceboolean = true;
    }

    this.empsvc
      .getOffboardingFeedbackTypeDescription(this.feedbacktype, this.code)
      .subscribe(
        (data: OffbaordingFeedbackTypeClass[]) => {
          if (data != null && data.length > 0) {
            if (isNullOrUndefined(this.code)) {
              for (var i = 0; i < data.length; i++) {
                this.resultArray[i] = new OffboardingCheckListResultClass();
                this.resultArray[i].FeedbackID = data[i].FeedbackID;
                this.resultArray[i].FeedbackDescription =
                  data[i].FeedbackDescription;
              }
            } else {
              data.forEach((item) => {
                let element = this.offboardingresult.filter(
                  (x) => x.FeedbackID == item.FeedbackID
                )[0];
                if (element != null) {
                  element.FeedbackDescription = item.FeedbackDescription;
                  this.resultArray.push(element);
                } else {
                  element = new OffboardingCheckListResultClass();
                  element.Empcode = this.empCode;
                  element.FeedbackID = item.FeedbackID;
                  element.FeedbackDescription = item.FeedbackDescription;
                  this.resultArray.push(element);
                }
              });
            }
          }

          for (var i = 0; i < this.resultArray.length; i++) {
            if (this.resultArray[i].FeedbackID == 5) {
              this.resultArray[i].radioNameYes = "Disable";
              this.resultArray[i].radioNameNo = "Delete";
              this.resultArray[i].radioNameNA = "Forward";
            } else {
              this.resultArray[i].radioNameYes = "Yes";
              this.resultArray[i].radioNameNo = "No";
              this.resultArray[i].radioNameNA = "N/A";
            }
            if (this.feedbacktype == "Manager") {
              this.EmployeeCode = this.resultArray[i].HRAnswerComments;
            }

            if (
              this.resultArray[i].RadioAnswer == 0 &&
              (this.resultArray[i].FeedbackID == 24 ||
                this.resultArray[i].FeedbackID == 25 ||
                this.resultArray[i].FeedbackID == 26 ||
                this.resultArray[i].FeedbackID == 27 ||
                this.resultArray[i].FeedbackID == 28 ||
                this.resultArray[i].FeedbackID == 29)
            ) {
              this.resultArray[i].showAmountBox = true;
            } else {
              this.resultArray[i].showAmountBox = false;
            }
            if (this.feedbackFinanceboolean == false) {
              this.dataSourceFTE.data = this.resultArray;
            }
            if (
              this.resultArray[i].RadioAnswer == 0 &&
              (this.resultArray[i].FeedbackID == 18 ||
                this.resultArray[i].FeedbackID == 19 ||
                this.resultArray[i].FeedbackID == 20)
            ) {
              this.resultArray[i].requiredAstricForAdmin = true;
            }
            if (
              this.resultArray[i].RadioAnswer == 0 &&
              (this.resultArray[i].FeedbackID == 24 ||
                this.resultArray[i].FeedbackID == 25 ||
                this.resultArray[i].FeedbackID == 26 ||
                this.resultArray[i].FeedbackID == 27 ||
                this.resultArray[i].FeedbackID == 28 ||
                this.resultArray[i].FeedbackID == 29 ||
                this.resultArray[i].FeedbackID == 30 ||
                this.resultArray[i].FeedbackID == 31)
            ) {
              this.resultArray[i].requiredAstric = true;
            }
          }

          if (
            this.feedbackFinanceboolean == true &&
            this.feedbacktype == "HR"
          ) {
            for (var i = 0; i < this.resultArray.length; i++) {
              if (
                this.resultArray[i].FeedbackID == 24 ||
                this.resultArray[i].FeedbackID == 25 ||
                this.resultArray[i].FeedbackID == 26 ||
                this.resultArray[i].FeedbackID == 27 ||
                this.resultArray[i].FeedbackID == 28 ||
                this.resultArray[i].FeedbackID == 29
              ) {
                this.financeresultArray.push(this.resultArray[i]);
              }
            }
            for (var i = 0; i < this.financeresultArray.length; i++) {
              if (this.feedbackFinanceboolean == true) {
                this.financeresultArray[i].showFinanceAmountBox = true;
              } else {
                this.financeresultArray[i].showFinanceAmountBox = false;
              }
            }
            this.dataSourceFTE.data = this.financeresultArray;
          }
        },
        (error) => (this.error = error)
      );
  }

  triggerDropdown(element: any, index: any) {
    element.requiredAstric = false;
    element.requiredAstricForAdmin = false;
    if (
      this.offboardingform.SubmittedManager == false ||
      this.offboardingform.SubmittedManager == null
    ) {
      if (this.feedbacktype == "Manager") {
        if (element.FeedbackID == 5) {
          if (element.RadioAnswer == 2) {
            this.getEmployeeList();
          } else {
            this.EmployeeCode = "";
          }
        }
      }
    }
    if (
      this.offboardingform.SubmittedHR == false ||
      this.offboardingform.SubmittedHR == null
    ) {
      if (this.feedbacktype == "HR") {
        element.HRAmount = "";
        element.showAmountBox = false;
      }
    } else if (
      this.disableHRformonFinSubmit == false &&
      this.offboardingform.SubmittedHR == true
    ) {
      if (this.feedbacktype == "HR") {
        element.HRAmount = "";
        element.showAmountBox = false;
      }
    }
  }

  triggerReqForAdmin(element: any) {
    element.requiredAstricForAdmin = true;
  }

  triggerAmountBox(element: any, flag) {
    // this.GetOffboardingChecklistResult()
    this.empsvc.getBasicEmployeeById(this.code).subscribe(
      (data: BasicEmployeeDetails) => {
        this.empDetails = data;
        const arr = [];
        let nDays = this.diffDays(
          new Date(this.empDetails.DOJ),
          new Date(this.empDetails.DateOfExit)
        );
        let recallApiDataArr: OffboardingCheckListResultClass[] = [];
        this.empsvc
          .GetOffboardingChecklistResult(this.code)
          .subscribe((data) => {
            recallApiDataArr = data;
            // const finalFilteredData = this.offboardingresult && this.offboardingresult.find(({FeedbackID})=>FeedbackID === element.FeedbackID)
            const finalFilteredData =
              recallApiDataArr &&
              recallApiDataArr.find(
                ({ FeedbackID }) => FeedbackID === element.FeedbackID
              );
            if (element.FeedbackID === 29) {
              const temp_value =
                (nDays < 365 ? this.empDetails.JoiningBonus : "0") || "0";
              element.HRAmount =
                (finalFilteredData && finalFilteredData.HRAmount) || temp_value;
              // nDays < 365
              // ?: 0;
              // arr.push({...item, HRAmount: temp_value})
            } else {
              element.HRAmount =
                finalFilteredData && finalFilteredData.HRAmount;
              // arr.push({...item})
            }
          });

        this.isshowHide = !this.isshowHide;
        // this.offboardingresult = arr
        this.joiningBonus = nDays < 365 ? this.empDetails.JoiningBonus : "0";
        if (
          this.offboardingform.SubmittedHR == false ||
          this.offboardingform.SubmittedHR == null
        ) {
          element.requiredAstric = true;
          if (
            element.FeedbackID == 24 ||
            element.FeedbackID == 25 ||
            element.FeedbackID == 26 ||
            element.FeedbackID == 27 ||
            element.FeedbackID == 28 ||
            element.FeedbackID == 29
          ) {
            element.showAmountBox = true;
          } else {
            element.showAmountBox = false;
          }
        } else if (
          this.disableHRformonFinSubmit == false &&
          this.offboardingform.SubmittedHR == true
        ) {
          element.requiredAstric = true;

          if (
            element.FeedbackID == 24 ||
            element.FeedbackID == 25 ||
            element.FeedbackID == 26 ||
            element.FeedbackID == 27 ||
            element.FeedbackID == 28 ||
            element.FeedbackID == 29
          ) {
            element.showAmountBox = true;
          } else {
            element.showAmountBox = false;
          }
        }
      },
      (error) => this.toastr.warning(error)
    );
  }

  changeEmpCode(event) {
    for (var i = 0; i < this.employeeList.length; i++) {
      var id = event.option.value.split("-");
      this.employeeList[i].FirstName = id[0];
      this.employeeList[i].Email = id[1];
    }
  }

  doFilter() {
    if (!isNullOrUndefined(this.EmployeeCode)) {
      this.filteredList = this.filter(this.tempdropdownList);
    }
  }

  filter(values) {
    return values.filter((value) =>
      value.DisplayName.toLowerCase().includes(this.EmployeeCode.toLowerCase())
    );
  }

  getEmployeeList() {
    this.empsvc.getAllEmployees().subscribe(
      (data: any[]) => {
        this.employeeList = data;
        this.managerVerifiedList = data;
        for (var i = 0; i < this.employeeList.length; i++) {
          if (this.employeeList[i].EmpCode == this.code) {
            this.employeeList.splice(i, 1);
          }
        }
        this.employeeList.forEach((el) => {
          let item = new dropObj();
          item.DisplayName = el.FirstName + "-" + el.Email;
          this.tempdropdownList.push(item);
        });
        this.filteredList = this.tempdropdownList;
      },
      (error) => (this.error = error)
    );
  }
  getITAccordions() {
    this.feedbacktypeAccordions = "Manager";
    this.empsvc
      .GetFeedbackAccordionData(this.feedbacktypeAccordions, this.code)
      .subscribe(
        (data: OffboardingCheckListResultClass[]) => {
          this.accordionManager = data;
          this.commentBooleanHR = true;
          for (var i = 0; i < this.accordionManager.length; i++) {
            if (this.accordionManager[i].FeedbackID == 5) {
              this.accordionManager[i].radioNameYes = "Disable";
              this.accordionManager[i].radioNameNo = "Delete";
              this.accordionManager[i].radioNameNA = "Forward";
            } else {
              this.accordionManager[i].radioNameYes = "Yes";
              this.accordionManager[i].radioNameNo = "No";
              this.accordionManager[i].radioNameNA = "N/A";
            }
            if (this.feedbacktype != "Manager") {
              this.EmployeeCode = this.accordionManager[i].HRAnswerComments;
            }
            this.dataSourceManager.data = this.accordionManager;
          }
        },
        (error) => (this.error = error)
      );
  }

  getAdminAccordions() {
    this.feedbacktypeAccordions = "IT";
    this.empsvc
      .GetFeedbackAccordionData(this.feedbacktypeAccordions, this.code)
      .subscribe(
        (data: OffboardingCheckListResultClass[]) => {
          this.accordionIT = data;
          this.commentBooleanHR = true;
          this.dataSourceIT.data = this.accordionIT;
        },
        (error) => (this.error = error)
      );
  }
  getHRAccordions() {
    this.feedbacktypeAccordions = "Admin";
    this.empsvc
      .GetFeedbackAccordionData(this.feedbacktypeAccordions, this.code)
      .subscribe(
        (data: OffboardingCheckListResultClass[]) => {
          this.accordionAdmin = data;
          this.commentBooleanHR = true;
          this.dataSourceAdmin.data = this.accordionAdmin;
        },
        (error) => (this.error = error)
      );
  }
  geFinanceAccordions() {
    this.feedbacktypeAccordions = "HR";
    this.empsvc
      .GetFeedbackAccordionData(this.feedbacktypeAccordions, this.code)
      .subscribe(
        (data: OffboardingCheckListResultClass[]) => {
          this.accordionHR = data;
          this.commentBooleanHR = true;
          this.dataSourceHR.data = this.accordionHR;
          for (var i = 0; i < this.accordionHR.length; i++) {
            if (
              this.accordionHR[i].RadioAnswer == 0 &&
              (this.accordionHR[i].FeedbackID == 24 ||
                this.accordionHR[i].FeedbackID == 25 ||
                this.accordionHR[i].FeedbackID == 26 ||
                this.accordionHR[i].FeedbackID == 27 ||
                this.accordionHR[i].FeedbackID == 28 ||
                this.accordionHR[i].FeedbackID == 29)
            ) {
              this.accordionHR[i].showAmountBox = true;
            } else {
              this.accordionHR[i].showAmountBox = false;
            }
          }
        },
        (error) => (this.error = error)
      );
  }
  GetOffboardingChecklistResult() {
    this.empsvc.getBasicEmployeeById(this.code).subscribe(
      (data: BasicEmployeeDetails) => {
        this.empDetails = data;
        this.empsvc.GetOffboardingChecklistResult(this.code).subscribe(
          (data) => {
            // this.offboardingresult = data;
            const arr = [];
            let nDays = this.diffDays(
              new Date(this.empDetails.DOJ),
              new Date(this.empDetails.DateOfExit)
            );
            data &&
              data.forEach((item) => {
                if (item.FeedbackID === 29) {
                  arr.push({
                    ...item,
                    HRAmount:
                      item.HRAmount ||
                      (nDays < 365 ? this.empDetails.JoiningBonus : "0"),
                  });
                } else {
                  arr.push({ ...item });
                }
              });
            this.offboardingresult = arr;
            this.offboardingresult_old = arr;
            this.getchecklist();
          },
          (error) => this.toastr.warning(error)
        );
      },
      (error) => this.toastr.warning(error)
    );
  }

  handleClick(element: any, item) {
    // this.GetOffboardingChecklistResult()
    this.empsvc.getBasicEmployeeById(this.code).subscribe(
      (data: BasicEmployeeDetails) => {
        this.empDetails = data;
        const arr = [];
        let nDays = this.diffDays(
          new Date(this.empDetails.DOJ),
          new Date(this.empDetails.DateOfExit)
        );
        // const finalFilteredData = this.offboardingresult_old && this.offboardingresult_old.find(({FeedbackID})=>FeedbackID === element.FeedbackID)
        let recallApiDataArr: OffboardingCheckListResultClass[] = [];
        this.empsvc
          .GetOffboardingChecklistResult(this.code)
          .subscribe((data) => {
            recallApiDataArr = data;

            const finalFilteredData =
              recallApiDataArr &&
              recallApiDataArr.find(
                ({ FeedbackID }) => FeedbackID === element.FeedbackID
              );

            if (element.FeedbackID === 29) {
              const tempValue =
                (nDays < 365 ? this.empDetails.JoiningBonus : "0") || "0";
              element.HRAmount =
                (finalFilteredData && finalFilteredData.HRAmount) || tempValue;
              // nDays < 365
              // ? : 0;
              // arr.push({...item, HRAmount: tempValue})
            } else {
              element.HRAmount =
                finalFilteredData && finalFilteredData.HRAmount;
              // arr.push({...item})
            }
          });
        // this.getchecklist();
        this.isshowHide = !this.isshowHide;
        // this.offboardingresult = arr
      },
      (error) => this.toastr.warning(error)
    );
  }

  GetFeedbackAnswersByCode() {
    this.empsvc.GetFbAnswers(this.code).subscribe(
      (data) => {
        this.question = data;
      },
      (error) => this.toastr.warning(error)
    );
  }

  getEmpDetails() {
    this.empsvc.getBasicEmployeeById(this.code).subscribe(
      (data: BasicEmployeeDetails) => {
        this.empDetails = data;
        this.getEmpListForLastTab();
      },
      (error) => this.toastr.warning(error)
    );
  }

  SaveFeedbackForm() {
    window.scrollTo(0, 0);
    this.loader = true;
    for (var i = 0; i < this.resultArray.length; i++) {
      this.resultArray[i].ReviewerCode = this.employeeCode;
      this.resultArray[i].CreatedBy = this.employeeCode;
      this.resultArray[i].ModifiedBy = this.employeeCode;
      this.resultArray[i].Empcode = this.code;
    }
    if (this.feedbacktype == "HR" && this.feedbackFinanceboolean == true) {
      this.offboardingform.FeedbackType = "Finance";
      this.offboardingform.financeStatusBoolean = false;
      if (!isNullOrUndefined(this.offboardingform.FinalSettlementDate)) {
        this.offboardingform.FinalSettlementDate = new Date(
          this.datePipe.transform(
            this.offboardingform.FinalSettlementDate,
            this.config.dateFormat()
          )
        );
      }
    }
    if (!isNullOrUndefined(this.code)) {
      this.offboardingform.EmpCode = this.code;
      this.offboardingform.ModifiedBy = this.employeeCode;
      this.checkFinalFeedbacks();
      if (this.feedbacktype == "Manager") {
        this.offboardingform.ManagerFeedBack = false;
      }
      if (this.feedbacktype == "IT") {
        this.offboardingform.ITSupportFeedback = false;
        this.offboardingform.FBType = "IT";
      } else if (this.feedbacktype == "Admin") {
        this.offboardingform.AdminFeedBack = false;
      } else if (
        this.feedbacktype == "HR" &&
        this.feedbackFinanceboolean == false
      ) {
        this.offboardingform.HRFinalFeedback = false;
        this.offboardingform.FeedbackType = null;
      } else if (
        this.feedbacktype == "HR" &&
        this.feedbackFinanceboolean == true
      ) {
        this.offboardingform.FinanceFeedback = false;
        this.offboardingform.FeedbackType = null;
      }
      this.offboardingform.NewITData = true;
      this.empsvc.SaveOffboardingDetails(this.offboardingform).subscribe(
        (data: any) => {
          if (data.ErrorType == "Exception") {
            this.toastr.warning(data.ErrorMsg);
          }
        },
        (error) => this.toastr.warning(error)
      );
    }
    if (this.feedbacktype == "Manager") {
      for (var i = 0; i < this.resultArray.length; i++) {
        if (
          this.resultArray[i].Empcode == this.code &&
          this.EmployeeCode != null
        )
          this.resultArray[i].HRAnswerComments = this.EmployeeCode;
      }
    }
    for (var i = 0; i < this.resultArray.length; i++) {
      if (
        this.resultArray[i].FeedbackID == 7 &&
        this.resultArray[i].RadioAnswer != 2
      ) {
        this.EmployeeCode = "";
      }
    }

    if (!isNullOrUndefined(this.EmployeeCode)) {
      if (this.EmployeeCode != "") {
        var mailCheckinList = this.tempdropdownList.filter(
          (x) => x.DisplayName == this.EmployeeCode
        );
        if (mailCheckinList.length == 0) {
          this.loader = false;
          this.toastr.warning(
            "Please select an Email from Forward Option dropdown."
          );
          this.EmployeeCode = "";
          return;
        }
      }
    }
    this.empsvc.SaveOffboardingChecklist(this.resultArray).subscribe(
      (data: any) => {
        this.SaveEmpFbAnswers();
        if (data.ErrorType == "Exception") {
          this.loader = false;
          this.toastr.warning(data.ErrorMsg);
        } else {
          this.toastr.success("Saved Successfully.");
          this.loader = false;
          this.router.navigateByUrl(
            `/Offboardinglist/tabIndex/${
              Number(sessionStorage.getItem("tabIndex")) || 0
            }`
          );
        }
      },
      (error) => this.toastr.warning(error)
    );
  }
  SubmitFeedbackForm() {
    var msg = `Are you sure to submit the form?`;
    var deleteType = "Submit";
    const dialogData = new ConfirmDialogModel(" ", msg, deleteType);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "800px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          window.scrollTo(0, 0);
          this.loader = true;
          for (var i = 0; i < this.resultArray.length; i++) {
            if (this.feedbacktype == "HR") {
              if (
                this.resultArray[i].RadioAnswer == 0 &&
                (this.resultArray[i].HRAnswerComments == null ||
                  this.resultArray[i].HRAnswerComments == "")
              ) {
                this.loader = false;
                this.toastr.warning(
                  "Please provide comments for Selected 'Yes'."
                );
                return;
              }
              if (
                this.resultArray[i].RadioAnswer == 0 &&
                this.resultArray[i].HRAnswerComments != null
              ) {
                if (
                  this.resultArray[i].HRAmount == null &&
                  (this.resultArray[i].FeedbackID == 24 ||
                    this.resultArray[i].FeedbackID == 25 ||
                    this.resultArray[i].FeedbackID == 26 ||
                    this.resultArray[i].FeedbackID == 27 ||
                    this.resultArray[i].FeedbackID == 28 ||
                    this.resultArray[i].FeedbackID == 29)
                ) {
                  this.loader = false;
                  this.toastr.warning(
                    "Please enter amount for applicable fields."
                  );
                  return;
                }
              }
            }
            this.resultArray[i].ReviewerCode = this.employeeCode;
            this.resultArray[i].Empcode = this.code;
            this.resultArray[i].CreatedBy = this.employeeCode;
            this.resultArray[i].ModifiedBy = this.employeeCode;
          }
          for (var i = 0; i < this.resultArray.length; i++) {
            if (this.feedbacktype == "Admin") {
              if (
                this.resultArray[i].RadioAnswer == 0 &&
                (this.resultArray[i].HRAnswerComments == null ||
                  this.resultArray[i].HRAnswerComments == "")
              ) {
                this.loader = false;
                this.toastr.warning(
                  "Please provide comments for Selected 'Yes'."
                );
                return;
              }
            }
            this.resultArray[i].ReviewerCode = this.employeeCode;
            this.resultArray[i].Empcode = this.code;
            this.resultArray[i].CreatedBy = this.employeeCode;
            this.resultArray[i].ModifiedBy = this.employeeCode;
          }
          if (
            this.feedbacktype == "HR" &&
            this.feedbackFinanceboolean == true
          ) {
            if (this.offboardingform.FinalSettlementDate == null) {
              this.loader = false;
              this.toastr.warning("Please enter 'Final Settlement' date.");
              return;
            }
            if (
              this.offboardingform.FinanceComments == null ||
              this.offboardingform.FinanceComments == ""
            ) {
              this.loader = false;
              this.toastr.warning("Please provide comments.");
              return;
            }
            if (!isNullOrUndefined(this.offboardingform.FinalSettlementDate)) {
              this.offboardingform.FinalSettlementDate = new Date(
                this.datePipe.transform(
                  this.offboardingform.FinalSettlementDate,
                  this.config.dateFormat()
                )
              );
            }
          }

          if (this.feedbacktype != "HR" && this.feedbacktype == "Manager") {
            for (var i = 0; i < this.resultArray.length; i++) {
              if (
                this.resultArray[i].Empcode == this.code &&
                this.EmployeeCode != null
              ) {
                this.resultArray[i].HRAnswerComments = this.EmployeeCode;
              }
              if (
                this.resultArray[i].FeedbackID == 5 &&
                this.resultArray[i].RadioAnswer == 2
              ) {
                if (
                  this.resultArray[i].HRAnswerComments == null ||
                  this.resultArray[i].HRAnswerComments == ""
                ) {
                  this.loader = false;
                  this.toastr.warning(
                    "Please select an Email from Forward Option dropdown"
                  );
                  return;
                }
                if (
                  this.resultArray[i].ForwardedMailNoOfDays == null ||
                  this.resultArray[i].ForwardedMailNoOfDays == 0
                ) {
                  this.loader = false;
                  this.toastr.warning("Please enter one or more days.");
                  return;
                }
              } else if (
                this.resultArray[i].FeedbackID == 5 &&
                this.resultArray[i].RadioAnswer != 2
              ) {
                this.EmployeeCode = "";
              }
            }
          }
          if (!isNullOrUndefined(this.EmployeeCode)) {
            if (this.EmployeeCode != "") {
              var mailCheckinList = this.tempdropdownList.filter(
                (x) => x.DisplayName == this.EmployeeCode
              );
              if (mailCheckinList.length == 0) {
                this.loader = false;
                this.toastr.warning(
                  "Please select an Email from Forward Option dropdown"
                );
                this.EmployeeCode = "";
                return;
              }
            }
          }
          if (!isNullOrUndefined(this.code)) {
            this.offboardingform.EmpCode = this.code;
            this.offboardingform.ModifiedBy = this.employeeCode;
            if (this.feedbacktype == "Manager") {
              this.offboardingform.FeedbackType = this.feedbacktype;
              this.offboardingform.ManagerFeedBack = true;
            }
            if (this.feedbacktype == "Admin") {
              this.offboardingform.FeedbackType = this.feedbacktype;
              this.offboardingform.AdminFeedBack = true;
            }
            if (this.feedbacktype == "IT") {
              this.offboardingform.FeedbackType = this.feedbacktype;
              this.offboardingform.ITSupportFeedback = true;
            }
            if (this.feedbacktype == "HR") {
              this.offboardingform.FeedbackType = this.feedbacktype;
              this.offboardingform.HRFinalFeedback = true;
            }
            if (
              this.feedbacktype == "HR" &&
              this.feedbackFinanceboolean == true
            ) {
              this.offboardingform.FeedbackType = "Finance";
              this.offboardingform.FinanceFeedback = true;
              this.offboardingform.financeStatusBoolean = true;
            }
            if (this.feedbacktype == "HR") {
              for (var i = 0; i < this.dataSource.data.length; i++) {
                if (this.dataSource.data[i].Answer == "") {
                  this.dataSource.data[i].Answer = null;
                }
                if (
                  !isNullOrUndefined(this.dataSource.data[i].Answer) == true
                ) {
                  this.dataSource.data[i].feedbackanswers = true;
                } else {
                  this.dataSource.data[i].feedbackanswers = true;
                }
              }
            }
            this.checkAlltrue = this.dataSource.data.filter(
              (x) => x.feedbackanswers == true
            );
            var submitradiocount = 0;
            for (var i = 0; i < this.resultArray.length; i++) {
              if (
                this.resultArray[i].RadioAnswer == 0 ||
                this.resultArray[i].RadioAnswer == 1 ||
                this.resultArray[i].RadioAnswer == 2
              ) {
                submitradiocount++;
              }
            }
            this.offboardingform.feedbackType = this.feedbacktype;
            if (
              submitradiocount == this.resultArray.length &&
              (this.checkAlltrue.length == 3 || this.feedbacktype != "HR")
            ) {
              if (this.feedbacktype == "Manager") {
                this.offboardingform.SubmittedManager = true;
                this.offboardingform.ManagerSubmittedBy = this.employeeCode;
                this.offboardingform.ManagerSubmittedOn = this.todayDate;
              } else if (this.feedbacktype == "IT") {
                this.offboardingform.SubmittedIT = true;
                this.offboardingform.ITSubmittedBy = this.employeeCode;
                this.offboardingform.ITSubmittedOn = this.todayDate;
              } else if (this.feedbacktype == "Admin") {
                this.offboardingform.SubmittedAdmin = true;
                this.offboardingform.AdminSubmittedBy = this.employeeCode;
                this.offboardingform.AdminSubmittedOn = this.todayDate;
              } else if (
                this.feedbacktype == "HR" &&
                this.feedbackFinanceboolean == false
              ) {
                this.offboardingform.SubmittedHR = true;
                this.offboardingform.HRSubmittedBy = this.employeeCode;
                this.offboardingform.HRSubmittedOn = this.todayDate;
              } else if (
                this.feedbacktype == "HR" &&
                this.feedbackFinanceboolean == true
              ) {
                this.offboardingform.SubmittedFinance = true;
                this.offboardingform.FinanceSubmittedBy = this.employeeCode;
                this.offboardingform.FinanceSubmittedOn = this.todayDate;
              }
              if (
                this.offboardingform.FinalSettlementDate != null &&
                (this.feedbacktype != "HR" ||
                  this.feedbackFinanceboolean == false)
              ) {
                this.offboardingform.FinalSettlementDate = null;
              }
              //this.offboardingform.FinalSettlementDate = this.offboardingform.FinalSettlementDate;
              this.empsvc.SubmitFeedbackForm(this.offboardingform).subscribe(
                (data: any) => {
                  if (data.ErrorType == "Exception") {
                    this.loader = false;
                    this.toastr.warning(data.ErrorMsg);
                  }
                },
                (error) => this.toastr.warning(error)
              );
            }
          }
          if (
            submitradiocount == this.resultArray.length &&
            (this.checkAlltrue.length == 3 || this.feedbacktype != "HR")
          ) {
            this.empsvc.SaveOffboardingChecklist(this.resultArray).subscribe(
              (data: any) => {
                this.SaveEmpFbAnswers();
                if (data.ErrorType == "Exception") {
                  this.loader = false;
                  this.toastr.warning(data.ErrorMsg);
                } else {
                  this.toastr.success("Submitted Successfully.");
                  this.loader = false;
                  this.router.navigateByUrl(
                    `/Offboardinglist/tabIndex/${
                      Number(sessionStorage.getItem("tabIndex")) || 0
                    }`
                  );
                }
              },
              (error) => this.toastr.warning(error)
            );
          } else {
            this.loader = false;
            this.toastr.warning("Please answer all the questions.");
          }
        }
      },
      (error) => {
        this.loader = false;
        this.result = error;
      }
    );
    return this.result;
  }
  Cancel() {
    this.router.navigateByUrl(
      `/Offboardinglist/tabIndex/${
        Number(sessionStorage.getItem("tabIndex")) || 0
      }`
    );
  }
  getToolTipData(element: any) {
    if (element.FeedbackID == 4 || element.FeedbackID == 19) {
      this.onlyifexits = true;
      this.tooltipdata = "if any";
    } else if (element.FeedbackID == 6) {
      this.tooltipdata =
        "In case of Email/Data Back - If Yes, please mention the storage location and the backup required in the comments section";
      this.onlyifexits = true;
    } else if (element.FeedbackID == 5) {
      this.tooltipdata =
        "In case of email forward - For Forward, Please select the employee to whom the email has to be forwarded";
      this.onlyifexits = true;
    } else if (element.FeedbackID == 8) {
      this.tooltipdata =
        "If yes, please mention in the comments section the details of the back-up required";
      this.onlyifexits = true;
    } else if (element.FeedbackID == 12) {
      this.tooltipdata =
        "Please provide asset serial number and other details in the comments section";
      this.onlyifexits = true;
    } else if (element.FeedbackID == 14) {
      this.tooltipdata = "like voip, data card, pen drive, etc. if any";
      this.onlyifexits = true;
    } else if (element.FeedbackID == 20) {
      this.tooltipdata =
        "like Mobile handset, SIM, files, folders, etc. if any";
      this.onlyifexits = true;
    } else if (element.FeedbackID == 38) {
      this.tooltipdata =
        "Please provide asset serial number and other details in the comments section";
      this.onlyifexits = true;
    } else if (element.FeedbackID == 39) {
      this.tooltipdata =
        "if dot forward should be update in comments with duration";
      this.onlyifexits = true;
    } else if (element.FeedbackID == 44) {
      this.tooltipdata = "WinWire BLR, WinWire HYD";
      this.onlyifexits = true;
    } else {
      this.onlyifexits = false;
      this.tooltipdata = "";
    }
  }
}
export class dropObj {
  DisplayName: string;
  Email: string;
}
